<template>
  <div>
    <h4 class="title">{{ $t('recent_ads') }}</h4>
    <template v-if="loading">
      <div
        class="card"
        fixed-header
        v-if="ads && ads.length > 0"
        style="box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08)"
      >
        <v-table>
          <thead>
            <tr>
              <th class="text-left">{{ $t('account') }}</th>
              <th class="text-left">{{ $t('ad_name') }}</th>
              <th class="text-left"> {{ $t('daily_budget') }} </th>
              <th class="text-left"> {{ $t('add_objective') }} </th>
              <th class="text-left">{{ $t('from_to') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ad, index) in ads" :key="index" class="mb-2">
              <td
                class="d-flex align-center"
                style="gap: 17px; padding: 40px 15px"
              >
                <div class="user-image position-relative">
                  <!-- <img
                    v-if="userAvatar"
                    class="user-avatar"
                    :src="ad?.userAvatar"
                    alt=""
                  />
                  <img
                    v-else
                    class="user-avatar"
                    src="@/assets/soft-ware-img/Shape.png"
                    alt=""
                  /> -->
                  <img
                    v-if="ad.platform === 'facebook'"
                    class="user-avatar"
                    src="@/assets/images/icons/facebook.svg"
                    alt="facebook"
                  />
                  <img
                    v-if="ad.platform === 'instagram'"
                    class="user-avatar"
                    src="@/assets/images/icons/instagram.svg"
                    alt="instagram"
                  />
                  <img
                    v-if="ad.platform === 'snapchat'"
                    class="user-avatar"
                    src="@/assets/images/icons/snapcaht.svg"
                    alt="snapchat"
                  />
                </div>
                <p>{{ ad.accountName }}</p>
              </td>
              <td>
                <p>{{ ad.name }}</p>
              </td>
              <td>
                <p>{{ ad.budget }} <span>$</span></p>
              </td>
              <td>
                <p>{{ ad.objective }}</p>
              </td>
              <td>
                <p>{{ ad.start_time }}</p>
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>
      <div v-else class="d-flex justify-center align-center">
        <div class="text-center">
          <img
            src="@/components/icons/activeadicons/no-account.png"
            alt="no data"
            class="mb-2"
          />
          <p>No Recent Ads</p>
        </div>
      </div>
    </template>
    <template v-else>
      <v-card class="pa-4">
        <v-skeleton-loader type="table-row-divider@6" class="w-100" />
      </v-card>
    </template>
  </div>
</template>
<script>
import GlobalNav from "@/components/layout/GlobalNav.vue";
import Edithome from "@/components/icons/posts/Edithome.vue";
import Deletehome from "@/components/icons/posts/Deletehome.vue";
import Scheduled from "@/components/home/Scheduled.vue";
import RecentAds from "@/components/home/RecentAds.vue";
export default {
  components: { GlobalNav, Edithome, Deletehome, Scheduled, RecentAds },
  name: "RecentAds",
  props: {
    ads: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatAdRange(rangeString) {
      if (!rangeString || !rangeString.includes("to")) return "Invalid Date";

      const [startRaw, endRaw] = rangeString.split(" to");

      const formatDate = (rawDate) => {
        const date = new Date(rawDate.trim());
        return date.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
        });
      };

      return `${formatDate(startRaw)} to ${formatDate(endRaw)}`;
    },
  },
};
</script>
<style scoped>
.custom-shadow {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);
}
.post-shadow {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08), 0px 0px 12px rgba(0, 0, 0, 0.08);
}
.recent-ads .card .v-table {
  box-shadow: none;
}
.posts-scheduled {
  height: auto !important;
}
</style>
